/* eslint-disable @typescript-eslint/no-explicit-any */
import { Collection, CollectionQuery } from "../../../models/collection.model"
import { Owner } from "../../../models/owner.model"
import { Tenant } from "../../../models/tenant.model"
import { notification } from "../../../shared/component/notification/utility/notification"
import { collectionQueryBuilder } from "../../../shared/utility/collection-builder/collection-query-builder"
import { appApi } from "../../../store/app.api"
import { TENANT_ENDPOINT } from "../tenant.endpoint"

let tenantCollection: CollectionQuery
let tenantCountCollection: CollectionQuery
let ownersOfTenantCollection: CollectionQuery
let archivedTenantCollection: CollectionQuery
const tenantQuery = appApi.injectEndpoints({
  endpoints: (builder) => ({
    getTenant: builder.query<Tenant, string>({
      query: (id: string) => ({
        url: `${TENANT_ENDPOINT.detail}/${id}`,
        method: "get",
      }),
      providesTags: ["Tenant"],
    }),

    getTenants: builder.query<Collection<Tenant>, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${TENANT_ENDPOINT.list}`,
        method: "GET",
        params: collectionQueryBuilder(data),
      }),
      providesTags: ["Tenants"],

      async onQueryStarted(param, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // if (data) {
          //   tenantCollection = param
          // }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),
    countTenants: builder.query<any, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${TENANT_ENDPOINT.list}`,
        method: "GET",
        params: collectionQueryBuilder(data),
      }),
      providesTags: ["Count Tenants"],

      async onQueryStarted(param, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // if (data) {
          //   tenantCountCollection = param
          // }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    getOwnersOfTenant: builder.query<Collection<Owner>, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${TENANT_ENDPOINT.getOwnersOfTenant}`,
        method: "GET",
        params: collectionQueryBuilder(data),
      }),
      async onQueryStarted(param, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // if (data) {
          //   ownersOfTenantCollection = param
          // }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    getArchivedTenant: builder.query<Tenant, string>({
      query: (id: string) => ({
        url: `${TENANT_ENDPOINT.archivedTenant}/${id}`,
        method: "get",
      }),
      providesTags: ["Archived Tenant"],
    }),

    getArchivedTenants: builder.query<Collection<Tenant>, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${TENANT_ENDPOINT.archivedTenants}`,
        method: "GET",
        params: collectionQueryBuilder(data),
      }),
      providesTags: ["Archived Tenants"],
      async onQueryStarted(param, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // if (data) {
          //   archivedTenantCollection = param
          // }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    createTenant: builder.mutation<Tenant, any>({
      query: (newData: any) => ({
        url: `${TENANT_ENDPOINT.create}`,
        method: "post",
        data: newData,
        permissions: "manage-tenants",
      }),
      invalidatesTags: ["Tenants", "Count Tenants", "Count Dashboard Tenants"],
      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully created")
            // dispatch(
            //   tenantQuery.util.updateQueryData(
            //     "getTenants",
            //     tenantCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data.unshift(data)
            //         draft.count += 1
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    importTenant: builder.mutation<Tenant, { id?: string; file?: any }>({
      query: (newData: { id?: string; file?: any }) => ({
        url: `${TENANT_ENDPOINT.import}/${newData.id}`,
        method: "post",
        data: newData?.file,
        permissions: "manage-tenants",
      }),
      invalidatesTags: ["Tenants", "Count Tenants", "Count Dashboard Tenants"],

      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully created")
            // dispatch(
            //   tenantQuery.util.updateQueryData(
            //     "getTenants",
            //     tenantCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data.unshift(data)
            //         draft.count += 1
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    updateTenant: builder.mutation<Tenant, any>({
      query: (newData: any) => ({
        url: `${TENANT_ENDPOINT.update}`,
        method: "put",
        data: newData,
        permission: "manage-tenants",
      }),
      invalidatesTags: ["Tenant", "Tenants", "Count Tenants"],
      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully updated")
            // dispatch(
            //   tenantQuery.util.updateQueryData(
            //     "getTenants",
            //     tenantCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft?.data?.map((tenant) => {
            //           if (tenant.id === data.id) return data
            //           else {
            //             return tenant
            //           }
            //         })
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    toggleTenantStatus: builder.mutation<Tenant, string>({
      query: (id: string) => ({
        url: `${TENANT_ENDPOINT.toggleStatus}/${id}`,
        method: "post",
        permission: "manage-tenants",
      }),
      invalidatesTags: ["Tenant", "Tenants", "Count Tenants"],
      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully updated status")
            // dispatch(
            //   tenantQuery.util.updateQueryData(
            //     "getTenants",
            //     tenantCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft?.data?.map((tenant: Tenant) => {
            //           if (tenant.id === data.id) return data
            //           else {
            //             return tenant
            //           }
            //         })
            //       }
            //     },
            //   ),
            // )
            // dispatch(
            //   tenantQuery.util.updateQueryData("getTenant", param, (draft) => {
            //     draft.enabled = data.enabled
            //   }),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),
    bulkToggleTenantStatus: builder.mutation<boolean, {ids: string[], enabled: boolean }>({
      query: (data: {ids: string[], enabled: boolean}) => ({
        url: `${TENANT_ENDPOINT.bulkToggleStatus}`,
        method: "post",
        permission: "manage-tenants",
        data: data
      }),
      invalidatesTags: ["Tenant", "Tenants", "Count Tenants"],
      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully updated status")
            // dispatch(
            //   tenantQuery.util.updateQueryData(
            //     "getTenants",
            //     tenantCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft?.data?.map((tenant: Tenant) => {
            //           if (tenant.id === data.id) return data
            //           else {
            //             return tenant
            //           }
            //         })
            //       }
            //     },
            //   ),
            // )
            // dispatch(
            //   tenantQuery.util.updateQueryData("getTenant", param, (draft) => {
            //     draft.enabled = data.enabled
            //   }),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),

    archiveTenant: builder.mutation<Tenant, { id: string; reason: string }>({
      query: (data) => ({
        url: `${TENANT_ENDPOINT.archive}`,
        method: "delete",
        data: data,
        permission: "manage-tenants",
      }),
      invalidatesTags: ["Tenant", "Tenants", "Count Tenants"],
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            // dispatch(
            //   tenantQuery.util.updateQueryData(
            //     "getTenants",
            //     tenantCollection,
            //     (draft) => {
            //       draft.data = draft?.data?.map((tenant) => {
            //         if (tenant.id === arg.id) {
            //           return data
            //         } else {
            //           return tenant
            //         }
            //       })
            //     },
            //   ),
            // )
            // dispatch(
            //   tenantQuery.util.updateQueryData(
            //     "getTenant",
            //     arg?.id,
            //     (draft) => {
            //       draft.deletedAt = data?.deletedAt
            //     },
            //   ),
            // )
            // dispatch(
            //   tenantQuery.util.updateQueryData(
            //     "getArchivedTenant",
            //     arg?.id,
            //     (draft) => {
            //       draft.deletedAt = data?.deletedAt
            //     },
            //   ),
            // )
            notification("success", "Successfully archived")
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),

    deleteTenant: builder.mutation<boolean, string>({
      query: (id: string) => ({
        url: `${TENANT_ENDPOINT.delete}/${id}`,
        method: "delete",
        permission: "manage-tenants",
      }),
      invalidatesTags: ["Tenant", "Tenants", "Count Tenants"],

      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully deleted")
            // dispatch(
            //   tenantQuery.util.updateQueryData(
            //     "getArchivedTenants",
            //     archivedTenantCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft.data.filter((tenant) => tenant.id !== id)
            //         draft.count -= 1
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),

    restoreTenant: builder.mutation<Tenant, string>({
      query: (id: string) => ({
        url: `${TENANT_ENDPOINT.restore}/${id}`,
        method: "post",
        permission: "manage-tenants",
      }),
      invalidatesTags: ["Tenant", "Tenants", "Count Tenants"],

      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            // dispatch(
            //   tenantQuery.util.updateQueryData(
            //     "getTenants",
            //     tenantCollection,
            //     (draft) => {
            //       draft.data = draft?.data?.map((tenant) => {
            //         if (tenant.id === id) {
            //           return data
            //         } else {
            //           return tenant
            //         }
            //       })
            //     },
            //   ),
            // )
            // dispatch(
            //   tenantQuery.util.updateQueryData("getTenant", id, (draft) => {
            //     draft.deletedAt = data?.deletedAt
            //   }),
            // )
            // dispatch(
            //   tenantQuery.util.updateQueryData(
            //     "getArchivedTenant",
            //     id,
            //     (draft) => {
            //       draft.deletedAt = data?.deletedAt
            //     },
            //   ),
            // )
            notification("success", "Successfully restored")
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),
  }),
  overrideExisting: true,
})
export const {
  useLazyGetArchivedTenantQuery,
  useLazyGetArchivedTenantsQuery,
  useLazyCountTenantsQuery,
  useLazyGetTenantQuery,
  useLazyGetTenantsQuery,

  useLazyGetOwnersOfTenantQuery,

  useUpdateTenantMutation,
  useCreateTenantMutation,
  useDeleteTenantMutation,
  useArchiveTenantMutation,
  useRestoreTenantMutation,
  useToggleTenantStatusMutation,
  useImportTenantMutation,
  useBulkToggleTenantStatusMutation
} = tenantQuery
